function initTooltips() {
  console.log('[Tooltip] initTooltips() aufgerufen');

  document.querySelectorAll('.tooltip-toggle').forEach(button => {
    if (button.dataset.tooltipProcessed === 'true') return;
    button.dataset.tooltipProcessed = 'true';

    button.addEventListener('click', function (e) {
      const tooltip = this.nextElementSibling;
      if (!tooltip) return;

      // Andere Tooltips schließen
      document.querySelectorAll('.tooltip-content').forEach(el => {
        if (el !== tooltip) el.classList.add('hidden');
      });

      tooltip.classList.toggle('hidden');
      e.stopPropagation();
    });
  });

  document.querySelectorAll('.tooltip-close').forEach(button => {
    if (button.dataset.tooltipProcessed === 'true') return;
    button.dataset.tooltipProcessed = 'true';

    button.addEventListener('click', function (e) {
      const tooltip = this.closest('.tooltip-content');
      if (tooltip) tooltip.classList.add('hidden');
      e.stopPropagation();
    });
  });

  document.querySelectorAll('.tooltip-content').forEach(tooltip => {
    if (tooltip.dataset.tooltipProcessed === 'true') return;
    tooltip.dataset.tooltipProcessed = 'true';

    tooltip.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  if (!window.tooltipOutsideClickBound) {
    document.addEventListener('click', () => {
      document.querySelectorAll('.tooltip-content').forEach(el => el.classList.add('hidden'));
    });
    window.tooltipOutsideClickBound = true;
  }
}


// Initial bei Page Load
document.addEventListener('DOMContentLoaded', initTooltips);

// Nochmal bei dynamischen Shopify-Aktionen
document.addEventListener('shopify:section:load', initTooltips);
document.addEventListener('shopify:block:select', initTooltips);

// Optional bei Cart-Updates, falls Subify, AJAX etc. verwendet wird
document.addEventListener('cart:updated', initTooltips);



function initBeforeAfterPopup() {
  document.querySelectorAll('.before-after-toggle').forEach(button => {
    button.addEventListener('click', () => {
      const popup = button.closest('.before-after-block')?.querySelector('.before-after-popup');
      if (popup) popup.classList.remove('hidden');
    });
  });

  document.querySelectorAll('.before-after-close').forEach(button => {
    button.addEventListener('click', () => {
      const popup = button.closest('.before-after-popup');
      if (popup) popup.classList.add('hidden');
    });
  });

  document.querySelectorAll('.before-after-popup').forEach(popup => {
    popup.addEventListener('click', (e) => {
      const inner = popup.querySelector('.before-after-popup-inner');
      if (!inner.contains(e.target)) {
        popup.classList.add('hidden');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initBeforeAfterPopup);
document.addEventListener('shopify:section:load', initBeforeAfterPopup);
document.addEventListener('shopify:block:select', initBeforeAfterPopup);

let tooltipTries = 0;
let tooltipMaxTries = 50; // 50 x 200ms = 10 Sekunden max

function tryTooltipInitUntilItWorks() {
  const buttonExists = document.querySelector('.tooltip-toggle');

  if (buttonExists) {
    console.log('[Tooltip] erfolgreich initialisiert');
    initTooltips();
    return;
  }

  tooltipTries++;
  if (tooltipTries < tooltipMaxTries) {
    setTimeout(tryTooltipInitUntilItWorks, 200);
  } else {
    console.warn('[Tooltip] auch nach 10 Sekunden nicht gefunden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  tryTooltipInitUntilItWorks();
});
